import { CLEAR_RETURN } from '../constants/ActionTypes'

export default function clearReturn(item) {
    return {
        type: CLEAR_RETURN,
        item
    }
}
